<script lang="ts" setup>
withDefaults(defineProps<{
  headerSize: 'small' | 'medium' | 'large' | 'full'
  title?: string
  description?: string
  breadcrumbs?: boolean
  header?: boolean
  padding?: boolean
  rounded?: boolean
}>(), { breadcrumbs: true, header: true, padding: true, rounded: true })
</script>

<template>
  <CustomerModuleLayoutHeader
    v-if="header"
    :title="title"
    :description="description"
    :size="headerSize"
    :breadcrumbs="breadcrumbs"
    :rounded="rounded"
    class="PagePadding"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template #headerExtra>
      <slot name="headerExtra" />
    </template>
    <template #titleExtra>
      <slot name="titleExtra" />
    </template>
  </CustomerModuleLayoutHeader>
  <div :class="{ 'PagePadding my-4 md:my-6': padding }">
    <CustomerModuleLayoutStatusBar />
    <slot />
  </div>
</template>
